import css from './graph.module.scss';

import _ from 'lodash';
import { memo } from 'react';

import cfg from './gridConstans';
import { TRect, TStep, TX, TY } from './type';

const { PADDING } = cfg.LEGEND;

const Legend = ({
  x,
  y,
  px,
  steps,
  graphRect,
  maxCount,
  maxWeeks,
}: {
  x: TX;
  y: TY;
  px: number;
  steps: TStep;
  graphRect: TRect;
  maxCount: number;
  maxWeeks: number;
}) => {
  const horisontal = _.range(steps.horisontal, maxWeeks + 1, steps.horisontal);
  const vertical = _.range(steps.vertical, maxCount + 1, steps.vertical);

  return (
    <g data-role="legend">
      <g data-role="axis">
        <text
          className={css.axisName}
          data-dir="vertical"
          children="cards →"
          y={graphRect.top + px * PADDING.VERTICAL}
          x={graphRect.right - px * PADDING.HORISONTAL}
        />
        <text
          className={css.axisName}
          data-dir="horisontal"
          children="weeks →"
          y={graphRect.top + px * PADDING.VERTICAL}
          x={graphRect.right - px * PADDING.HORISONTAL}
        />
      </g>

      <g data-dir="horisontal">
        {horisontal.map(num => (
          <text
            key={num}
            x={x(num)}
            y={graphRect.bottom + px * PADDING.HORISONTAL}
            className={css.legendText}
            children={num}
            data-dir="horisontal"
          />
        ))}
      </g>

      <g data-dir="vertical">
        {vertical.map(num => (
          <text
            key={num}
            y={y(num)}
            x={graphRect.left - px * PADDING.VERTICAL}
            className={css.legendText}
            children={num}
            data-dir="vertical"
          />
        ))}
      </g>
    </g>
  );
};

export default memo(Legend);
